import { render, staticRenderFns } from "./PlayerRenownSent.vue?vue&type=template&id=8c782caa&scoped=true&"
import script from "./PlayerRenownSent.vue?vue&type=script&lang=js&"
export * from "./PlayerRenownSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c782caa",
  null
  
)

export default component.exports